$ = require 'jquery'
templates = require 'views/internal/templates'

module.exports = Tooltip = new class
  constructor: ->
    @tooltip = null

  show: (tooltipHtml, $anchor, closeable = true, style = @STYLE.DEFAULT) ->
    $(window).on 'click', $anchor[0], @windowClick

    clearTimeout(@emptyTimer)

    if (typeof tooltipHtml.renderOnce == 'function')
      tooltipHtml = tooltipHtml.renderOnce().$el.html()

    $elem = $(templates.fill('tooltip_content', { tooltipHtml, closeable, style }))

    # remove all classes except @TOOLTIP_CONTAINER
    $tooltip = $('.' + @TOOLTIP_CONTAINER).attr('class', @TOOLTIP_CONTAINER)

    if style != @STYLE.DEFAULT
      $tooltip.addClass('tooltip-' + style)

    $tooltip.html $elem
    @tooltip = {
      tooltipHtml
      $anchor
      $elem
    }

    { left: anchor_left, top: anchor_top } = $anchor.offset()
    anchor_height = $anchor.outerHeight()
    min_right_offset = window.innerWidth - 100

    $tooltip.css
      left: Math.min(Math.max(anchor_left - 5, 5), min_right_offset)
      top: Math.max(anchor_top + anchor_height, 5)

    $elem.addClass('active')

  windowClick: (e) ->
    $target = $(e.target)
    if (e.target != e.data &&
    $target.closest('.js-tooltip-content').length == 0 ||
    $target.closest('.js-tooltip-close-button').length != 0)
      Tooltip.hide()

  hide: ->
    @tooltip = null
    $tooltip = $('.' + @TOOLTIP_CONTAINER)
    $tooltip
      .find('.tooltip-content')
      .removeClass('active')
    @emptyTimer = setTimeout =>
      $tooltip.empty()
    , 300

    $(window).off 'click', @windowClick

  STYLE: {
    DEFAULT: 'default',
    MENU: 'menu',
    BILLING: 'billing'
  }

  TOOLTIP_CONTAINER: 'tooltip-container'



// WEBPACK FOOTER //
// ./app/scripts/views/lib/tooltip.coffee